import { toast } from "sonner";
import { api } from "./api";

export const WA_NUMBER = "32497503915";
export const TEL_NUMBER = "+32497503915";

// Opens the native WhatsApp app via the `whatsapp://` deep link. If the app is
// not installed (deep link doesn't fire), we fall back to the wa.me web page so
// the user is never stuck on a blank screen.
export function openWhatsApp(text) {
  const native = `whatsapp://send?phone=${WA_NUMBER}&text=${encodeURIComponent(text)}`;
  const web = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;
  const start = Date.now();
  const fallback = setTimeout(() => {
    if (document.visibilityState === "visible" && Date.now() - start < 2500) {
      window.location.href = web;
    }
  }, 1200);
  // If the app opens, the page is backgrounded — cancel the web fallback.
  document.addEventListener("visibilitychange", () => clearTimeout(fallback), { once: true });
  window.location.href = native;
}

// Notifies the garage (email + push) and opens WhatsApp with an urgent message
// + the client's live GPS location. If the location can't be obtained, the
// message still asks the client to share their location manually in WhatsApp.
export function triggerDepannage(t, client = {}, lang = "fr") {
  const tr = (k, fb) => (t ? t(k) : fb);
  const intro = tr("depannage.wa_intro", "🚨 DÉPANNAGE URGENT — Garage Ter Spelt.");
  const shareHint = tr("depannage.share_hint", "📍 Je vais partager ma position ici (trombone → Localisation).");
  const base = { name: client?.name || "", email: client?.email || "", phone: client?.phone || "", lang };
  const notify = (extra) => { api.post("/depannage", { ...base, ...extra }).catch(() => {}); };

  if (!("geolocation" in navigator)) {
    toast.error(tr("depannage.no_geo", "Localisation indisponible."));
    notify({});
    openWhatsApp(`${intro}\n\n${shareHint}`);
    return;
  }

  const loadingId = toast.loading(tr("depannage.locating", "Localisation en cours…"));

  const onSuccess = (pos) => {
    toast.dismiss(loadingId);
    const { latitude, longitude } = pos.coords;
    const maps = `https://maps.google.com/?q=${latitude},${longitude}`;
    notify({ lat: latitude, lng: longitude, maps_url: maps });
    openWhatsApp(`${intro}\n\n📍 ${tr("depannage.my_pos", "Ma position")} : ${maps}`);
  };

  const onError = (err) => {
    toast.dismiss(loadingId);
    toast.error(err && err.code === 1
      ? tr("depannage.geo_denied", "Localisation refusée — partagez votre position dans WhatsApp.")
      : tr("depannage.geo_fail", "Position introuvable — partagez-la dans WhatsApp."));
    notify({});
    openWhatsApp(`${intro}\n\n${shareHint}`);
  };

  // High-accuracy first; on timeout, retry once with a faster low-accuracy lookup.
  navigator.geolocation.getCurrentPosition(
    onSuccess,
    (err) => {
      if (err && err.code === 3) {
        navigator.geolocation.getCurrentPosition(onSuccess, onError, { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 });
      } else {
        onError(err);
      }
    },
    { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
  );
}
